import { Helmet } from "react-helmet-async";
import { usePortalBranding } from "@/contexts/portalBranding";
import { useFavicon } from "@/lib/favicon";

/**
 * Document title + favicon for a white-label portal (ticket 4).
 *
 * Renders nothing when unbranded, leaving the index.html Reveshare defaults
 * in place — the same pattern BrandLayout uses for the brand tenant shell.
 * Mounted at the app root (host branding, covers login/signup) and again
 * inside AffiliateLayout, where the deeper mount wins and follows the
 * authenticated affiliate's scope.
 *
 * The favicon goes through useFavicon rather than Helmet: see lib/favicon
 * for why a second `<link rel="icon">` never beat the shell's SVG.
 */
export function PortalBrandingHead() {
  const { isWhiteLabel, portalName, portalLogo } = usePortalBranding();
  useFavicon(isWhiteLabel ? portalLogo : null);
  if (!isWhiteLabel) return null;

  return (
    <Helmet>
      <title>{portalName}</title>
    </Helmet>
  );
}
